import { render, staticRenderFns } from "./ChatMessageComposer.vue?vue&type=template&id=4ecd970e&scoped=true"
import script from "./ChatMessageComposer.vue?vue&type=script&lang=js"
export * from "./ChatMessageComposer.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageComposer.vue?vue&type=style&index=0&id=4ecd970e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd970e",
  null
  
)

export default component.exports